import { GroupPropertiesPage } from './../groupProperties/groupProperties';
import { HandmadeQueriesPage } from './../handmade-queries/handmade-queries';
import { LoginPage } from './../login/login';

import {Component, ElementRef, ViewChild, Renderer2} from '@angular/core';
import {style, state, animate, transition, trigger} from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, Events } from 'ionic-angular';
import { ApiServiceProvider } from "../../providers/api.service";
import { FiltersServiceProvider } from "../../providers/filters.service";


@IonicPage()
@Component({
  selector: 'page-groups',
  templateUrl: 'groups.html',
  
})
export class GroupsPage {

  

  public container;
  private originalGroups;
  private filteredGroups;
  private selectedGroup;
  private selectedGroupRoot = GroupPropertiesPage;

  searchTerm: string ='';
  items: any;


  @ViewChild('groupPropertiesNav') groupPropertiesNav: NavController;
  @ViewChild('groupListing') groupListing;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public api : ApiServiceProvider,
              public filters: FiltersServiceProvider,
              private renderer: Renderer2,
              private modalCtrl: ModalController,
              private events : Events) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ParticipantsPage');
    this.api.get('/groups', {populate:true}).then((result)=>{
      console.log("groups are ", result)
      this.originalGroups = result;
      this.filteredGroups = Object.assign([],result);  
    }).catch((error)=>{
      console.log(error);
    })
    // this.api.get('/participants').then((result)=>{
    //   console.log(result);
    // })

  }

  
  createNewParticipant(){

  }

  createNewGroup(){

    let pgroup = document.createElement('participant-group');
    // this.container = this.renderer.selectRootElement('#container');

    this.renderer.appendChild(this.container, pgroup);
  }

  groupSelected(event, group){

    let selectedGroupElement = event.currentTarget;

    console.log("click!!", group);
    
    this.selectedGroup = group;
    this.events.publish("groupProperties:groupChanged", group);

    
    let groupElements = this.groupListing.nativeElement.querySelectorAll('.group');
    for(let i=0; i<groupElements.length; i++) {
      this.renderer.removeClass(groupElements[i], "selected");
    }
    this.renderer.addClass(selectedGroupElement, "selected");
    /**
     * need to be able to set:
     *  name <input>
     *  comments <input>
     *  variables <input for now, possibly some key-value composition widget later?
     *  elements <select out of a list
     *  members : list of members, create a member of delete a member
     * 
     *  this should be a separate page
     * 
     *  
     *  
     */
  }


  setFilteredItems()
  {
    
    this.filteredGroups = this.filters.filterObjectArray(this.searchTerm, this.originalGroups, "groups");
  }



}



// WEBPACK FOOTER //
// ./src/pages/groups/groups.ts